// extracted by mini-css-extract-plugin
export default {"split":"TableItem_split__EALn4","stretch":"TableItem_stretch__kP3OM"};